import { render, staticRenderFns } from "./HomePurchase.vue?vue&type=template&id=3f2b8aa7&scoped=true"
import script from "./HomePurchase.vue?vue&type=script&lang=js"
export * from "./HomePurchase.vue?vue&type=script&lang=js"
import style0 from "./HomePurchase.vue?vue&type=style&index=0&id=3f2b8aa7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2b8aa7",
  null
  
)

export default component.exports